import React, { useEffect, Suspense } from "react";
import { Route, Routes, useNavigate, useLocation, useSearchParams } from "react-router-dom";

const HomePage = React.lazy(() => import("../components/routes/homePage"));
const LP = React.lazy(() => import("../components/routes/lp"));
const BeforePage = React.lazy(() => import("../components/routes/beforePage"));
const DuringPage = React.lazy(() => import("../components/routes/duringPage"));
const AfterPage = React.lazy(() => import("../components/routes/afterPage"));

const AppRouter = (props) => {
  const pageParam = new URLSearchParams(window.location.search).get("route");
  const videoId = new URLSearchParams(window.location.search).get("video");
  const redirect = ["before", "during", "after", "lp"].includes(pageParam);
  let navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  let query = "";
  for (const entry of searchParams.entries()) {
    if (entry[0] !== "route") {
      query += entry[0] + "=" + entry[1] + "&";
    }
  }
  query = query.slice(0, -1);

  useEffect(() => {
    if (redirect) {
      navigate(`/${pageParam}${query ? "?" + query : ""}`, { state: { videoId: videoId } });
    }
  }, [navigate, pageParam, redirect, videoId, query]);

  useEffect(() => {
    if (!redirect) {
      navigate(`/after${query ? "?" + query : ""}`, { replace: true });
    }
  }, []);

  return (
    <Suspense fallback={<></>}>
      <Routes key={location.pathname} location={location}>
        <Route exact path="/" element={<HomePage {...props.home_page} />} />
        <Route
          path="/before"
          element={<BeforePage {...props.before_inner_page} color="color-1" videoId={videoId && videoId} />}
        />
        <Route path="/during" element={<DuringPage {...props.during_inner_page} color="color-2" />} />
        <Route path="/after" element={<AfterPage {...props.after_inner_page} color="color-3" />} />
        <Route path="/lp" element={<LP {...props.home_page} />} />
      </Routes>
    </Suspense>
  );
};

export default AppRouter;
